import Image from 'next/image';

type Props = {
  size?: number;
  onClick: () => void;
};

export const BackButton = ({ size = 20, onClick }: Props) => {
  return (
    // 負のmarginでレイアウト上の大きさを20pxのアイコンと同じに保ち、タイトルや周りの配置を動かさずに押せる範囲だけを44pxに広げる
    <button type="button" onClick={onClick} aria-label="戻る" className="-m-3 inline-flex h-11 w-11 items-center justify-center text-gray-400 active:opacity-50">
      <Image src="/icons/left-icon.svg" alt="" width={size} height={size} />
    </button>
  );
};
